function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

import _ from 'underscore';

var METADATA_CLASS = 'edge.aspects.validation.dto.RuleAugmentationRuleDTO';
var alwaysTrue = _.constant(true);

/**
 * Returns a list of augments derived from the metadata.
 * @param {Object} expressionLanguage
 * @param {Object} metadata
 * @param {String} targetType
 * @param {String} targetPath
 * @param {Object} currentNode
 * @param {Object} parentNode
 * @returns {Array}
 */
function getAugmentsFromMeta(expressionLanguage, metadata, targetType, targetPath, currentNode, parentNode) {
    var augments = metadata.elementMetadata.get(METADATA_CLASS);
    var res = [];

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = augments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var augment = _step.value;

            if (augment.targets.indexOf(targetPath) === -1) {
                continue; // eslint-disable-line no-continue
            }

            var shouldApply = void 0;
            if (augment.when) {
                (function () {
                    var cond = expressionLanguage.compile(augment.when);
                    shouldApply = function shouldApply() {
                        /* Explicit cast to a true due to three-state value: true, false and NONSENSE. */
                        return cond(currentNode, parentNode, currentNode.aspects.context) === true;
                    };
                })();
            } else {
                shouldApply = alwaysTrue;
            }

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = augment.augments[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var override = _step2.value;

                    if (override.type === targetType) {
                        res.push({
                            'shouldApply': shouldApply,
                            'data': override.value,
                            'node': currentNode,
                            parentNode: parentNode
                        });
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return res;
}

/**
 * Collects rules from all the nodes.
 * @param {Object} expressionLanguage
 * @param {Object} node
 * @param {Object} nodeMetadata
 * @param {*} ancestorChain
 * @param {String} targetType
 * @returns {Array}
 */
function collectRules(expressionLanguage, node, nodeMetadata, ancestorChain, targetType) {
    var res = [];
    var localMeta = nodeMetadata.elementMetadata.get(targetType);
    localMeta.forEach(function (targetMeta) {
        res.push({
            'shouldApply': _.constant(true),
            'data': targetMeta,
            node: node,
            'parentNode': ancestorChain.parent
        });
    });

    for (var ancestorIdx = ancestorChain.owners.length - 1; ancestorIdx >= 0; ancestorIdx--) {
        var owner = ancestorChain.owners[ancestorIdx];
        var parent = ancestorIdx === 0 ? undefined : ancestorChain.owners[ancestorIdx - 1].container;
        var inheritedAugments = getAugmentsFromMeta(expressionLanguage, owner.metadata, targetType, owner.pathToItem.asString, owner.container, parent);
        res.push.apply(res, _toConsumableArray(inheritedAugments));
    }

    return res;
}

/** Utilities for the augmentable properties. */
export default {
    collectRules: collectRules
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-viewmodel-js/aspects/_Augment.js
// module id = 327
// module chunks = 0